import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=b1be9710&scoped=true"
import script from "./sideBar.vue?vue&type=script&lang=js"
export * from "./sideBar.vue?vue&type=script&lang=js"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=b1be9710&prod&lang=css"
import style1 from "./sideBar.vue?vue&type=style&index=1&id=b1be9710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1be9710",
  null
  
)

export default component.exports